import { render } from "./ButtonClearTags.vue?vue&type=template&id=6a835916"
import script from "./ButtonClearTags.vue?vue&type=script&lang=js"
export * from "./ButtonClearTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__